"use client";
import ReactiveBreadcrumb from "@cc/breadcrumb";
import { Stack } from "@mui/material";
import { MotionTypography } from "@cc/motion-components";
import SectionWrapper from "@cc/section-wrapper";
import { StaticImageData } from "next/image";
import ArrowBannerBackground, {
  ArrowBannerBackgroundProps,
} from "@/commonComponents/arrow-banner-background";
import { isArray } from "lodash";

export interface WardhaBannerProps {
  data: {
    banner: ArrowBannerBackgroundProps["images"] | string | StaticImageData;
    title: string;
  };
}

const WardhaBanner = (props: WardhaBannerProps) => {
  const { data } = props;
  const { banner, title } = data;
  return (
    <SectionWrapper
      SectionProps={{
        sx: {
          background: (theme) =>
            `${theme.palette.gradient.darkToTransparentRight}, ${
              banner &&
              !isArray(banner) &&
              (typeof banner === "string" || "src" in banner)
                ? `url(${typeof banner === "string" ? banner : banner.src})`
                : ""
            } no-repeat`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          position: "relative",
        },
      }}
      py={{ xs: 2, md: 4 }} // Todo: basePy
      pb={{ xs: 4, md: 8 }}
    >
      <ReactiveBreadcrumb />
      {isArray(banner) && (
        <ArrowBannerBackground
          images={banner as ArrowBannerBackgroundProps["images"]}
        />
      )}
      {title && (
        <Stack mt={{ xs: 18.125, md: 23.5 }} maxWidth={863} rowGap={3}>
          <MotionTypography variant="h1">{title}</MotionTypography>
        </Stack>
      )}
    </SectionWrapper>
  );
};

export default WardhaBanner;
